import { createTheme, darken } from "@mui/material/styles";
import { theme as _theme } from "@/layouts/theme";

const rootElement = () => document.getElementById("__next");

export const theme = createTheme({
    cssVariables: true,
    direction: "rtl",
    palette: {
        primary: _theme.colors.primary,
        gray: _theme.colors.gray,
        green: _theme.colors.green,
        orange: _theme.colors.orange,
    },
    components: {
        MuiPopover: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiPopper: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiDrawer: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiModal: {
            defaultProps: {
                container: rootElement,
            },
        },
    },
});
